import React from "react";
import "./Footer.css";
import { GrTwitter } from "react-icons/gr";
import { BsGithub } from "react-icons/bs";
import { SiHackerrank } from "react-icons/si";
import { AiFillLinkedin } from "react-icons/ai";

const Footer = () => {
  return (
    <footer>
     
      <div className="footer__socials">
        <a
          href="https://www.linkedin.com/in/waris-muneer-khan-7601b6232/"
          target="_blank"
        >
          <AiFillLinkedin />
        </a>
        <a href="https://github.com/warismuneerkhan" target="_blank">
          <BsGithub />
        </a>
        <a href="https://www.hackerrank.com/wariskhan8303276" target="_blank">
          <SiHackerrank />
        </a>
        <a href="https://twitter.com/WarisKh14895361" target="_blank">
          <GrTwitter />
        </a>
      </div>
      <div className="footer__copyrihght">
        <small>Made with ❤️ by Waris Khan ©️&nbsp; {new Date().getFullYear()}</small>
      </div>
    </footer>
  );
};

export default Footer;
